import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "sendmoney",
  UserStorage: "35qp8Er/4U6JHb3acBVbNQ==",
  UserToken: "eSYzpH+kIEGXJK+MfurdNQ==",
  UrlApi: "https://prd-ecommerce-snd-api.primecase.com.br/api",
  UrlLoja: "https://prd-ecommerce-snd-web.primecase.com.br",
  UrlServiceHost: "https://prd-snd-svc-api.primecase.com.br/",
  SecurityKey: "1S6XMXYQpVrtU52gDOt3",
  OrgId: "",
  ProviderMerchantId: "",
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#26b6a4",
      light: "#89dbd1ff",
      //lighter: "#ece6f7",
      dark: darkenColor("#26b6a4", 30), // Escurece em 20%
    },
    secondary: {
      main: "#316787",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
